// // Copyright Open Trade Technology Ltd. 2023. All rights reserved.
import Box from '@mui/material/Box'
import FormControl from '@mui/material/FormControl'
import FormHelperText from '@mui/material/FormHelperText'
import MenuItem from '@mui/material/MenuItem'
import Select, { SelectChangeEvent } from '@mui/material/Select'
import Typography from '@mui/material/Typography'
import { CompanyProfileAddressItem } from '@react/admin/CompanyProfileAddressItem'
import { toCompanyAddrString } from '@react/fetchers/companyProfileFetchers'
import { useOtSelector, OtStoreState } from '@react/redux/store'
import { EthAddr } from '@shared/SchemaTypes'
import { ZeroAddress } from 'ethers'
import React, { useState } from 'react'

export default function ReportLenderSelector(props: {
  lenderAddrs: EthAddr[]
  onSelectedChange: (lenderAddr: EthAddr) => void
}): React.ReactElement {
  const [lenderAddr, setLenderAddr] = useState<EthAddr>(
    props.lenderAddrs.length > 0 ? props.lenderAddrs[0] : ZeroAddress
  )
  const companyProfiles = useOtSelector((state: OtStoreState) => state.poolState.companyProfiles)

  const lenderAddrCompare = (a: EthAddr, b: EthAddr) => {
    const companyA = toCompanyAddrString(a, companyProfiles).display
    const companyB = toCompanyAddrString(b, companyProfiles).display
    return companyA.localeCompare(companyB)
  }
  return (
    <Box sx={{ flexGrow: 0, width: 450, flexDirection: 'column', display: 'flex' }}>
      <Typography sx={{ marginTop: -1, marginBottom: 1, height: 24 }} variant="caption">
        Lender
      </Typography>
      <FormControl sx={{ m: 0, width: 420, padding: 0 }} size="medium">
        <Select
          size="medium"
          style={{ width: 420 }}
          labelId="lender-label"
          id="lender-select"
          value={lenderAddr ?? ('' as string)}
          renderValue={(value: string) => {
            if (value === ZeroAddress) {
              return <Typography variant="bodyBold">---- Select Lender ----</Typography>
            }
            return <CompanyProfileAddressItem walletAddr={value} />
          }}
          onChange={(event: SelectChangeEvent) => {
            setLenderAddr(event.target.value as EthAddr)
            props.onSelectedChange(event.target.value as EthAddr)
          }}
        >
          <MenuItem
            value={ZeroAddress}
            key={ZeroAddress}
            style={{
              paddingLeft: 12,
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'flex-start',
              alignItems: 'center',
            }}
          >
            <Typography variant="bodyBold">---- Select Lender ----</Typography>
          </MenuItem>
          {props.lenderAddrs.sort(lenderAddrCompare).map((lenderAddr: EthAddr) => {
            return (
              <MenuItem value={lenderAddr} key={`${lenderAddr}`}>
                <CompanyProfileAddressItem hasBorder={true} walletAddr={lenderAddr} />
              </MenuItem>
            )
          })}
        </Select>
        {props.lenderAddrs.length == 0 && <FormHelperText error>Select Pool First</FormHelperText>}
        {props.lenderAddrs.length !== 0 && !lenderAddr && <FormHelperText error>* required</FormHelperText>}
      </FormControl>
    </Box>
  )
}
